import { MenuCalendar } from './MenuCalendar';
import { MenuDivider } from './MenuDivider';
import { MenuFooter } from './MenuFooter';
import { MenuHeader } from './MenuHeader';
import { MenuHeaderInput } from './MenuHeaderInput';
import { MenuHeaderSearch } from './MenuHeaderSearch';
import { MenuItem } from './MenuItem';
import { MenuItemCheckbox } from './MenuItemCheckbox';
import { MenuItemNested } from './MenuItemNested';
import { MenuItemRadio } from './MenuItemRadio';
import { MenuItemSwitch } from './MenuItemSwitch';
import { MenuItemText } from './MenuItemText';
import { MenuLabel } from './MenuLabel';
import { MenuRoot } from './MenuRoot';
import { MenuTextArea } from './MenuTextArea';
import { MenuTextInput } from './MenuTextInput';
export const Menu = {
    Root: MenuRoot,
    Item: MenuItem,
    ItemText: MenuItemText,
    ItemNested: MenuItemNested,
    ItemCheckbox: MenuItemCheckbox,
    ItemRadio: MenuItemRadio,
    ItemSwitch: MenuItemSwitch,
    Header: MenuHeader,
    HeaderInput: MenuHeaderInput,
    HeaderSearch: MenuHeaderSearch,
    Footer: MenuFooter,
    Divider: MenuDivider,
    Label: MenuLabel,
    Calendar: MenuCalendar,
    TextInput: MenuTextInput,
    TextArea: MenuTextArea,
};
